import { Injectable } from '@angular/core';
import {MessageService} from '../base/message.service';
import {HttpClient, HttpParams} from '@angular/common/http';

import {Service} from '../base/service';
import {Loggers} from '../../../util/app-util';
import {matrizTransicionEntity} from '../../../elements/riesgo-credito/entities_riesgos/entities_riesgos';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
  providedIn: 'root'
})
export class MatrizTransicionService extends Service<matrizTransicionEntity>{

  httpClient: HttpClient;
  constructor(
    http: HttpClient,
    messageService: MessageService,
    protected override logger: Loggers,
    cookiesService: CookieService
  ) { 
    super('concentracion','',http, messageService, logger, cookiesService);
    this.httpClient = http;
  }
  protected getParams(entity: matrizTransicionEntity):HttpParams{
    let params: HttpParams = new HttpParams();
    if (null == entity){return params;}
    if (null != entity.InstitucionId){params = params.set('InstitucionId', entity.InstitucionId)}
    if (null != entity.Periodo){params = params.set('Periodo', entity.Periodo)}
    if (null != entity.PeriodoAnterior){params = params.set('PeriodoAnterior', entity.PeriodoAnterior)}
    if (null != entity.NDatos){params = params.set('NDatos', entity.NDatos)}
    if(null !== entity.TipoCreditoId){params = params.set('TipoCreditoId', entity.TipoCreditoId)}
    if (null != entity.BnIntereses){params = params.set('BnIntereses', entity.BnIntereses.toString())}
    if (null != entity.ZonaId){params = params.set('ZonaId', entity.ZonaId)}
    if (null != entity.ProductoId){params = params.set('ProductoId', entity.ProductoId)}
    if (null != entity.SectorId){params = params.set('SectorId', entity.SectorId)}
    if (null != entity.SucursalId){params = params.set('SucursalId', entity.SucursalId)}
    return params;
  }
}
